module.exports = __webpack_public_path__ + "img/public/SiteIcons/learnIcon.png?04d0950e";